export default "__VITE_ASSET__C2a_EpXQ__"